import { lazy } from 'react';

export const DashboardContainer = lazy(() => import('containers/Dashboard/DashboardContainer'));

export const PageNotFoundContainer = lazy(() => import('containers/PageNotFound/PageNotFoundContainer'));
